import { defineComponent as _defineComponent } from 'vue'
import { ref, withDefaults } from '../../../../../adapter-vue';
import { transformTextWithKeysToEmojiNames } from '../../../../TUIChat/emoji-config';
import { IHighlightContent } from '../../../type';

interface IProps {
  content: IHighlightContent[];
  highlightType: 'font' | 'background';
  displayType: 'info' | 'bubble';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'message-abstract-text',
  props: {
    content: { default: () => ([]) as IHighlightContent[] },
    highlightType: { default: 'font' },
    displayType: { default: 'info' }
  },
  setup(__props: any) {

const props = __props as { content: IHighlightContent[], highlightType: 'font' | 'background', displayType: 'info' | 'bubble' }



const contentText = ref<Array<{ text: string; isHighlight: boolean }>>(props.content);

return { __sfc: true,props, contentText, transformTextWithKeysToEmojiNames }
}

})